import Icon from "@client/controls/Icon/component";
import Accordion from "@common/controls/Accordion";
import { AutoExpandItems } from "@common/controls/Accordion/component";
import { IconType } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import { i18nFormat } from "@common/lib/i18n";
import * as React from "react";
import { type KnowledgeBase } from "../types";
import { type CategoryEx } from "./lib";

type Props = {
  articles: KnowledgeBase.Api.Article[];
  categories: CategoryEx[];
  category: CategoryEx;
  getIsExpanded: (category: KnowledgeBase.Api.ArticleCategory) => boolean;
  index: number;
  level: number;
  onArticleClick: (article: KnowledgeBase.Api.Article) => void;
  style: React.CSSProperties;
};
const Item = (props: Props) => {
  const i18n = useI18n();

  const articles = React.useMemo(
    () => props.articles.filter((a) => a.articleCategoryId === props.category.articleCategoryId),
    [props.articles, props.category]
  );

  // TODO: get rid of this. Probably re-use getRadioButtonGroupStyle/getRadioButtonStyle
  const itemTitleStyle = React.useMemo((): React.CSSProperties => {
    const result: React.CSSProperties = {
      ...props.style,
      borderBottom: "none",
      borderLeft: "none",
      borderRight: "none"
    };

    if (props.level > 1 || (props.index > 0 && props.index < props.categories.length - 1)) {
      result.borderTopLeftRadius = 0;
      result.borderTopRightRadius = 0;
      result.borderBottomLeftRadius = 0;
      result.borderBottomRightRadius = 0;
    } else if (props.index === 0) {
      result.borderBottomLeftRadius = 0;
      result.borderBottomRightRadius = 0;
    } else if (props.index === props.categories.length - 1) {
      result.borderTopLeftRadius = 0;
      result.borderTopRightRadius = 0;
    }

    if (props.level === 1) {
      result.borderTop = "none";
    }

    return result;
  }, [props.level, props.index, props.style]);

  const info = React.useMemo(() => {
    if (!articles.length) return;

    return articles.length === 1 ? i18n.oneArticle : i18nFormat(i18n.nArticles, ["N", articles.length]);
  }, [articles.length]);

  const isExpanded = React.useMemo(() => props.getIsExpanded(props.category), [props.category, props.getIsExpanded]);

  return (
    <Accordion
      autoExpand={isExpanded ? AutoExpandItems.First : AutoExpandItems.None}
      style={{ "--level": props.level } as any}
      theme="default"
    >
      <Accordion.Item info={info} label={props.category.name} titleStyle={itemTitleStyle}>
        {props.category.categories.map((x, i) => (
          <Item
            key={x.articleCategoryId}
            articles={props.articles}
            category={x}
            categories={props.category.categories}
            getIsExpanded={props.getIsExpanded}
            index={i}
            level={props.level + 1}
            onArticleClick={props.onArticleClick}
            style={props.style}
          />
        ))}
        {articles.map((x) => (
          <div
            key={x.articleId}
            style={{
              ...props.style,
              borderLeft: 0,
              borderRight: 0,
              borderBottom: 0,
              borderRadius: 0
            }}
            onClick={() => props.onArticleClick(x)}
            className="article_title"
          >
            <Icon className="article_icon" iconClassName={IconType.Memo} />
            <span>{x.title}</span>
          </div>
        ))}
      </Accordion.Item>
    </Accordion>
  );
};
export default Item;
